import {useCallback, useState} from "react";
import {useNavigate} from "react-router-dom";
import {deleteRecord} from "../services/AccountsService.ts";
import {useUserAccount} from "../../../../hooks/useUserAccount.ts";


interface DeleteAccountFormFields {
    confirmation: boolean;
}

// FNP-117: drives the Delete Account form. Calls the new console-api
// `deleteAccount` mutation (FNP-285) which flips the row to
// PENDING_DELETION and emits the EventBridge event the workflows-api
// playbook consumes. After success, holds the user on the confirmation
// panel for 5s so the 30-day recovery message is read, then signs them
// out.
const SIGN_OUT_DELAY_MS = 5000;

export const useDeleteAccountForm = () => {

    const navigate = useNavigate()
    const {userAccount} = useUserAccount()
    const [submitted, setSubmitted] = useState(false)

    const initialValues: DeleteAccountFormFields = {
        confirmation: true,
    };

    const submitForm = async (values: DeleteAccountFormFields) => {

        console.debug('delete account form values', values)

        if (!userAccount?.id) {
            throw new Error('userAccount.id is required to delete the account');
        }

        await deleteRecord(userAccount.id);
        setSubmitted(true);
        setTimeout(() => navigate('/sign-out'), SIGN_OUT_DELAY_MS);
    }


    const handleSubmit = useCallback(
        (values: DeleteAccountFormFields) => {
            return submitForm(values)
                .then(() => {
                    console.log('Form submitted!');
                });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [userAccount?.id],
    );

    const handleCancel = () => {
        navigate('/account')
    }

    return {
        initialValues,
        handleSubmit,
        handleCancel,
        submitted,
    };
};
